import { memo } from "react";
import { Link } from "react-router-dom";

export default memo(function CardProject({ obj }) {
  return (
    <div key={obj.id} className="sp-hover-box">
      <img
        src={obj.photo}
        alt={obj.name}
        className="object-cover w-full h-full"
      />

      {/* *********************************************************************************************************** */}
      <div className="sp-text">
        <h3 className="bg-primary-green text-white font-bold text-xl px-3">
          {obj.name}
        </h3>

        {/* *********************************************************************************************************** */}

        <div className="bg-[#ffffffc7] px-3 py-2 ">
          {/* *********************************************************************************************************** */}

          <p>{obj.desc}</p>

          {/* *********************************************************************************************************** */}
          <div className="mt-2 flex items-center justify-between text-white">
            <Link
              to={Boolean(obj.demo) && obj.demo}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => {
                if (!Boolean(obj.demo)) e.preventDefault();
              }}
              className={`
                          bg-custom-black py-2 px-5 rounded-md gap-2
                          ${
                            !Boolean(obj.demo) &&
                            "opacity-50 cursor-not-allowed pointer-events-none"
                          }
                        `}
            >
              View
            </Link>
            <Link
              to={Boolean(obj.github) && obj.github}
              target="_blank"
              rel="noreferrer"
              onClick={(e) => {
                if (!Boolean(obj.github)) e.preventDefault();
              }}
              className={`
                         bg-custom-black py-2 px-5 rounded-md gap-2
                         ${
                           !Boolean(obj.github) &&
                           "opacity-50 cursor-not-allowed pointer-events-none"
                         }
                       `}
            >
              Code
            </Link>
          </div>
          {/* *********************************************************************************************************** */}
        </div>
        {/* *********************************************************************************************************** */}
      </div>
    </div>
  );
});
